import React, { useState } from "react";
import Hubspot from "./Hubspot";
import Loading from "../../../../Components/Loading";
import CompanyBranchView from "../../../../Components/corporate/CompanyBranchView";
import CompanyBranchForm from "../../../../Components/corporate/CompanyBranchForm";
import { ButtonPrimary } from "../../../../Components/Button";
import { connect } from "react-redux";
import { token } from "../../../../modules/auth";
import {
  canManageCompanyUsers,
  isAgencyAdmin,
  isCompanyAdmin,
  isRoleEdgeAdmin,
  isRolePlatformAdmin,
} from "../../../../modules/permissions";
import {
  createCompanyBranch,
  deleteCompanyBranch,
  disableCompanyUserByToken,
  editCompanyBranch,
} from "../../../../redux/actions";
import { isDirty } from "redux-form/immutable";
import {
  deleteInvite,
  resendInvite,
} from "../../../../redux/actions/corporateInvites";
const mapStateToProps = state => {
  return {
    ...state.company,
    token: token(state),
    isRoleEdgeAdmin: isRoleEdgeAdmin(state.auth),
    isRolePlatformAdmin: isRolePlatformAdmin(state.auth),
    isAgencyAdmin: isAgencyAdmin(state.auth),
    isCompanyAdmin: isCompanyAdmin(state.auth),
    canManageCompanyUsers: canManageCompanyUsers(state.auth),
    isDirty: isDirty("companyForm")(state),
    loggedInUser: state.auth.user,
  };
};

const allOption = {
  label: "Select all",
  value: "*",
};

const mapDispatchToProps = {
  editCompanyBranch,
  createCompanyBranch,
  deleteCompanyBranch,
  disableCompanyUserByToken,
};

let CompanyBranches = ({
  isFetchingCompanyBranches,
  companyBranches,
  countries,
  editCompanyBranch,
  deleteCompanyBranch,
  createCompanyBranch,
  company,
  token,
  isDirty,
}) => {
  const [addNewCompanyBranch, setAddNewCompanyBranches] = useState(false);
  let onSubmitCompanyBranchEdit = formValues => {
    let id = formValues.get("id");
    formValues.delete("id");
    return editCompanyBranch(id, company.id, formValues, token);
  };
  let onDeleteCompanyBranch = id => {
    if (window.confirm("Are you sure you want to deactivate this branch?")) {
      return deleteCompanyBranch(id, company.id, token);
    }
  };
  let onSubmitCompanyBranchCreate = formValues => {
    return createCompanyBranch(company.id, formValues, token);
  };

  return (
    <div className="py-10">
      <h3 className={"uppercase pt-5 border-t border-grey my-5"}>
        Manage Branches
      </h3>
      <div className={"row"}>
        {isFetchingCompanyBranches ? (
          <Loading />
        ) : companyBranches && companyBranches.length > 0 ? (
          companyBranches
            .sort((a, b) => new Date(a.deleted_at) - new Date(b.deleted_at))
            .map((companyBranch, id) => {
              return (
                <div
                  key={id}
                  className={"w-full bg-light-grey my-2 px-10 py-4"}
                >
                  {companyBranch.deleted_at ? (
                    <CompanyBranchView companyBranch={companyBranch} />
                  ) : (
                    <CompanyBranchForm
                      form={`companyBranchForm${id}`}
                      companyBranch={companyBranch}
                      countries={countries}
                      onSubmit={onSubmitCompanyBranchEdit}
                      onDeactivateBranch={onDeleteCompanyBranch}
                    />
                  )}
                </div>
              );
            })
        ) : null}
        {addNewCompanyBranch ? (
          <div className={"w-full bg-light-grey my-2 px-10 py-4"}>
            <CompanyBranchForm
              form={"companyBranchForm"}
              countries={countries}
              onSubmit={onSubmitCompanyBranchCreate}
              showDelete={false}
            />
          </div>
        ) : null}
        <div className="col">
          <ButtonPrimary
            type="button"
            onClick={() => setAddNewCompanyBranches(!addNewCompanyBranch)}
          >
            {addNewCompanyBranch ? "Cancel" : "Add Branch"}
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyBranches);
